// extracted by mini-css-extract-plugin
module.exports = {"infoCircle":"ReleaseForm-module__infoCircle___16J5b"};